import type { IconData } from '@stacksjs/iconify-core'

export const travelPlane: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 0L0 2l5.75 5.75L3.5 10H0a6 6 0 0 0 6 6v-3.5l2.25-2.25L14 16l2-2l-2.857-7.143l2.029-2.029a2.829 2.829 0 0 0-4-4l-2.03 2.03z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default travelPlane
